export default __webpack_public_path__ + "static/media/benefits_of_virtual_tour.91ba6368.png";